import React from "react";
import UnifiedPreview from "./UnifiedPreview";

const PreviewPage = () => {
  return <UnifiedPreview />;
};

export default PreviewPage; 